import { render, staticRenderFns } from "./GDPRDelete.vue?vue&type=template&id=b84a8a38&"
import script from "./GDPRDelete.vue?vue&type=script&lang=js&"
export * from "./GDPRDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b84a8a38')) {
      api.createRecord('b84a8a38', component.options)
    } else {
      api.reload('b84a8a38', component.options)
    }
    module.hot.accept("./GDPRDelete.vue?vue&type=template&id=b84a8a38&", function () {
      api.rerender('b84a8a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/GDPRDelete.vue"
export default component.exports